import { useI18n } from '../i18n';

const techs = [
  'React',
  'TypeScript',
  'Node.js',
  'Python',
  'PostgreSQL',
  'AWS',
  'Docker',
  'Kubernetes',
  'Tailwind CSS',
  'Vite',
  'GraphQL',
  'Rust',
];

export default function TechStack() {
  const { t } = useI18n();

  return (
    <section id="tech" className="bg-[#FFFBEB] px-6 py-24">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-['Russo_One'] text-4xl uppercase text-[#0F172A] md:text-5xl">
            {t('tech.title')}
          </h2>
          <p className="mt-4 text-lg text-[#78350F]">{t('tech.subtitle')}</p>
        </div>
        <div className="flex flex-wrap justify-center gap-4">
          {techs.map((tech) => (
            <span
              key={tech}
              className="border-2 border-[#F59E0B] px-5 py-2 font-semibold uppercase tracking-wider text-[#0F172A] transition-colors hover:bg-[#F59E0B] hover:text-[#0F172A]"
            >
              {tech}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
